const ADMIN_EMAILS = ['tiffany@southjerseyvendormarket.com'];

export { ADMIN_EMAILS };
